export default "__VITE_ASSET__c9d8cb5c__"